import React, { createContext, useContext, useState } from "react";

// Create the SearchContext
const SearchContext = createContext();

// Provider Component
export const SearchProvider = ({ children }) => {
    const [query, setQuery] = useState("");

    return (
        <SearchContext.Provider value={{ query, setQuery }}>
            {children}
        </SearchContext.Provider>
    );
};

// Custom hook to use the SearchContext
export const useSearch = () => {
    return useContext(SearchContext);
};
